export default [
    {
        'authorizationServerId': 'c8f0bf49-4744-4933-8960-7add6e590841',
        'customerFriendlyName': 'Mock Bank',
        'customerFriendlyLogoUri': 'https://cdn.raidiam.io/directory-ui/brand/obbrazil/0.2.0.112/favicon.svg',
        'bankCodeId': '999',
        'organizationName': 'Mock Bank',
        'organizationId': '74e929d9-33b6-4d85-8ba7-c146c867a817'
    }
];
